import { Box } from '@material-ui/core';
import { LenderApprovalStatus } from '@nemuru-eng/js-api-client';
import { useEffect } from 'react';

import { useChangeLenderApprovalStatus } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/components/LoanApplicationActionDialog/hooks/useChangeLenderApprovalStatus';
import { UseDialogProps } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/components/LoanApplicationActionDialog/LoanApplicationActionDialog';
import {
  ChangeLenderApprovalStatusSchema,
  ChangeLenderApprovalStatusType,
} from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/components/LoanApplicationActionDialog/schemas/ChangeLenderApprovalStatusSchema';
import { LenderApprovalStatusOptions } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/constants/LenderApprovalStatusOptions';
import { SelectFormField } from '@/components/shared/components/NewContextForms/SelectFormField';
import { EditDialogWrapper } from '@/components/shared/components/EditDialogWrapper';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

interface ChangeLenderApprovalStatusActionDialogProps {
  loanId: string;
  loanApplicationId: string;
  setLoanApplicationAction: (e) => void;
  useDialogProps: UseDialogProps;
  lenderApprovalStatus?: LenderApprovalStatus | null;
}

export const ChangeLenderApprovalStatusActionDialog = ({
  loanId,
  loanApplicationId,
  setLoanApplicationAction,
  lenderApprovalStatus,
  useDialogProps,
}: ChangeLenderApprovalStatusActionDialogProps) => {
  const { loading, changeLenderApprovalStatus } = useChangeLenderApprovalStatus({
    loanId,
    loanApplicationId,
  });

  const { opened, setOpened, toggleDialog } = useDialogProps;

  useEffect(() => {
    return () => {
      () => setLoanApplicationAction(undefined);
    };
  }, []);

  const changeLenderApprovalStatusDefaultValues = {
    lenderApprovalStatus: lenderApprovalStatus ?? null,
  };

  const onSubmitForm = async (values: ChangeLenderApprovalStatusType) => {
    await changeLenderApprovalStatus({
      lenderApprovalStatus: values.lenderApprovalStatus,
    });
    setOpened(false);
  };

  return (
    <EditDialogWrapper
      opened={opened}
      setOpened={setOpened}
      handleClose={toggleDialog}
      DialogProps={{
        maxWidth: 'sm',
        fullWidth: true,
      }}
      title={'CHANGE_LENDER_APPROVAL_STATUS'}
      saveButtonTextId={'MODIFY'}
      onSubmitForm={onSubmitForm}
      isLoading={loading}
      formSchema={ChangeLenderApprovalStatusSchema}
      defaultValues={changeLenderApprovalStatusDefaultValues}
    >
      <>
        <Font variant="body2" color="textSecondary">
          <Text tId={'CHANGE_LENDER_APPROVAL_STATUS_DESCRIPTION'} />
        </Font>
        <Box pt={3}>
          <SelectFormField
            label={'LENDER_APPROVAL_STATUS'}
            name={'lenderApprovalStatus'}
            selectOptions={LenderApprovalStatusOptions}
          />
        </Box>
      </>
    </EditDialogWrapper>
  );
};
